import { Collection, CollectionPrinter } from "@tblabs/truffle";
import { TableField } from "./TableField";
import { TableItemEditor } from "./TableItemEditor";
import { FieldEditor } from "../../Utils/FieldEditor";
import { Field } from "../../../Models/Description/Field";
import { TableItem } from "../../../Models/Description/Table/TableItem";
import { Tab } from "../../../Models/Product/Tab";
import { SecondaryButton } from "../../Utils/SecondaryButton";


export class TableItemsEditor extends FieldEditor
{
    constructor(field: TableField, fields: Collection<Field>, tabs: Collection<Tab>)
    {
        super("Tabela", field, fields, tabs, [
            new CollectionPrinter(field.Rows, x => new TableItemEditor(x, field.Rows)),
            new SecondaryButton("➕ Dodaj wiersz").OnClick(() => field.Rows.Add(new TableItem({ Left: "", Right: "" }))),
        ]);
    }
}
